import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { PrivateCompanyLeadData, PrivateCompanyLeadResponse } from "../types/privateCompanyLead";

const usePrivateCompanyLead: (id: string, enabled?: boolean) => UseQueryResult<PrivateCompanyLeadData, unknown> = (id, enabled = true) => {
  const privateAxios = usePrivateAxios()

  return useQuery<PrivateCompanyLeadResponse, unknown, PrivateCompanyLeadData>({
    enabled,
    queryKey: ['privateCompanyLead', id],
    queryFn: () => {
      return privateAxios.get(`/funnel/private_company_leads/${id}`)
    },
    select: (data) => data?.data?.data
  });
}

export default usePrivateCompanyLead
